import { Roles, Subjects } from "settings/permissions";

export const REDIRECT_TO_MSP_ADMIN = "/admin/accounts"; // USED FOR LEGACY ONBOARDING PROCESS

export const enterpriseAdminPages = {
  id: "Enterprise Admin",
  label: "Enterprise Admin",
  icon: "users",
  className: "last-root",
  permissions: {
    subject: Subjects.Client_MSP_Information,
    role: Roles.Read,
  },
  items: [
    {
      label: "Overview",
      path: "/admin/overview",
      requireClientSelection: false,
      topLabel: <></>,
    },
  ],
  isSingle: true,
};
